const url = `/api/v1/actions`;

export default url;
